import { render, staticRenderFns } from "./modalAreaLaboratorio.vue?vue&type=template&id=30c7cf29&"
import script from "./modalAreaLaboratorio.vue?vue&type=script&lang=js&"
export * from "./modalAreaLaboratorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports